export const ImpexOperations = "ImpexOperations";
export const SupplierOperations = "SupplierOperations";
export const ImpexFinance = "ImpexFinance";
export const SupplierFinance = "SupplierFinance";
export const ImpexAdmin = "ImpexAdmin";
export const SupplierAdmin = "SupplierAdmin";
export const SuperAdmin = "SystemAdmin";
